module.exports = __webpack_public_path__ + "media/images/help-521c48c2.png";